import { useContext } from 'react';
import { ProfileRestrictionContext } from '@/components/ProfileRestriction/context';

export const useProfileRestriction = () => {
  const context = useContext(ProfileRestrictionContext);

  if (!context) {
    throw new Error(
      'useProfileRestriction must be used inside ProfileRestrictionProvider',
    );
  }

  return context;
};
